// removed by extract-text-webpack-plugin
module.exports = {"performance-list":"_1b-XGy5Pl _2l0xl0HVf _2cxE75SKM IwP1PAeyl","header":"_2Rs4M3WxC _2l0xl0HVf xBrMYP3IH","date":"_2I-MfXifG _1yJuXbiru _3QqAd54bs _13qojEuKg _3-7RXEMuO _1C-lRJLgc hxreTUKKY _1B4qcaoCi ODSLv4a7K _35zMaXy4P _2BH_6_kaD _6yTQLo9ug _23s7Mrdy_","tickets":"_3oqPc1peN _2l0xl0HVf _1yJuXbiru _3QqAd54bs _13qojEuKg _1BE2U7F8v _1C-lRJLgc hxreTUKKY _2tvY6e7Hw NtaDwUdHI","total-partner-share":"_2JocWR_ev _3oqPc1peN _2l0xl0HVf _1yJuXbiru _3QqAd54bs _13qojEuKg _1BE2U7F8v _1C-lRJLgc hxreTUKKY _2tvY6e7Hw NtaDwUdHI"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/performance-list/performance-list.css
 ** module id = 2147
 ** module chunks = 0
 **/